import { globals } from "./_globals.js";
import { recursiveOffsetLeft } from "@/scripts/helpers.js";

export default {
  // maintain for constant updating
  originX: globals.vW / 2,
  originY: globals.vH / 2,
  loneX: 0,
  loneY: 0,
  loneZ: 0,
  radius: globals.rem * 1,
  fallTimeout: null,
  fallTime: 2000,
  isFall: false,
  init() {
    this.setTarget();
    this.isFall = false;
    for (const shape of globals.shapes) {
      shape.resetProps();
      shape.decelDist = 0.25 * globals.vMin;
      shape.setPropLerp("scale", 1.25);
      if (globals.isOut)
        shape.setProp("pos", { x: globals.rem * -2, y: this.originY, z: 50 });
    }
  },
  update() {
    this.radius = this.isFall ? globals.rem * 1.25 : globals.rem * 2;

    for (let i = 0; i < globals.shapes.length; i++) {
      const shape = globals.shapes[i];
      const phase =
        performance.now() / 900 +
        (i * Math.PI) / (this.isFall ? 1.5 : 2) +
        Math.PI * 0.66;
      if (!globals.isLeaving) {
        if (!this.isFall || i < globals.shapes.length - 1) {
          shape.setTarget(
            this.originX + Math.cos(phase) * this.radius,
            this.originY + Math.sin(phase) * this.radius
          );
        } else {
          shape.setTarget(this.loneX, this.loneY, this.loneZ);
        }
      }
      shape.update();
    }
  },
  setTarget() {
    if (globals.targetElement && !globals.isLeaving) {
      this.originX =
        recursiveOffsetLeft(globals.targetElement) +
        globals.targetElement.offsetWidth / 2;
      this.originY = globals.targetElement.offsetTop - globals.rem * 4;
      this.loneX =
        recursiveOffsetLeft(globals.targetElement) +
        globals.targetElement.offsetWidth * 0.75;
      this.loneY =
        globals.targetElement.offsetTop +
        globals.targetElement.offsetHeight +
        globals.rem * 4;
      this.loneZ = -globals.vMin / 2;
    }
  },
  onResize() {
    this.setTarget();
  },
  in() {
    this.fallTimeout = setTimeout(() => {
      this.isFall = true;
    }, this.fallTime);
  },
  out() {
    clearTimeout(this.fallTimeout);
    let i = 0;
    this.outInterval = setInterval(() => {
      const shape = globals.shapes[i];
      shape.setTarget(globals.vW / 2, globals.vH + 2 * globals.rem, this.loneZ);
      if (i >= globals.shapes.length - 1) {
        clearInterval(this.outInterval);
        return;
      }
      i++;
    }, 100);
  },
  kill() {
    clearTimeout(this.fallTimeout);
    clearInterval(this.outInterval);
  },
  onVisibilityChange() {},
  next() {},
};
